import { ReactNode } from "react";
import { Link } from "react-router-dom";
import DashboardLinkIcon from "../../assets/icons/DashboardLinkIcon";
import { addZeroIfInRange } from "../../utils/number";

interface TopBarCardProps {
  title: string;
  color: string;
  img: string;
  count?: ReactNode;
  className?: string;
  titleCount?: number;
  link?: string;
  query?: string;
}

export default function TopBarCard({
  title,
  color,
  img,
  count,
  className = "",
  titleCount,
  link,
  query = "",
}: TopBarCardProps) {
  return (
    <Link
      to={link ? `${link}?${query}` : ""}
      className={link ? "cursor-pointer" : "cursor-auto"}
    >
      <div
        className={`min-h-[100px] bg-white rounded-md outline outline-[0.50px] flex items-center relative ${className}`}
        style={{ outlineColor: color }}
      >
        {!!link && (
          <span className="absolute top-3 right-3">
            <DashboardLinkIcon />
          </span>
        )}
        <div
          className="w-[60px] min-h-[100px] h-full flex justify-center items-center"
          style={{ backgroundColor: color }}
        >
          <img src={img} alt="" />
        </div>

        <div className="px-3.5 py-2">
          <h2 className="text-body text-4xl font-bold uppercase mb-1">
            {typeof count === "number" ? addZeroIfInRange(count || 0) : count}
          </h2>
          <p className="text-extra-gray text-base font-medium flex items-center gap-1">
            {title}

            {titleCount || titleCount === 0 ? (
              <span className="text-primary">({titleCount})</span>
            ) : null}
          </p>
        </div>
      </div>
    </Link>
  );
}
